import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { ChatCircleDots } from "@phosphor-icons/react";
import { toast } from "sonner";

export function DiscussButton({ recordType, recordId, label, testId }) {
  const nav = useNavigate();
  async function open() {
    try {
      const { data } = await api.post("/chat/channels", {
        kind: "record",
        record_type: recordType,
        record_id: recordId,
        name: label ? `${recordType.replace("_", " ")}: ${label}` : undefined,
      });
      nav(`/chat/${data.id}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not open discussion");
    }
  }
  return (
    <button
      type="button"
      onClick={open}
      title="Open discussion thread"
      className="inline-flex items-center justify-center h-8 w-8 rounded border border-border text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
      data-testid={testId || `discuss-${recordType}-${recordId}`}
    >
      <ChatCircleDots size={14} />
    </button>
  );
}
